import { render, staticRenderFns } from "./FillupRegister.vue?vue&type=template&id=45d7528a&scoped=true"
import script from "./FillupRegister.vue?vue&type=script&lang=js"
export * from "./FillupRegister.vue?vue&type=script&lang=js"
import style0 from "./FillupRegister.vue?vue&type=style&index=0&id=45d7528a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d7528a",
  null
  
)

export default component.exports